import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from "react-redux";
import * as css from 'styles'
import styled from '@emotion/styled'
import preventWidowedWords from 'utils/preventWidowedWords'

import { Meta, Link, Img, Grid, Loading } from 'components'

const ArticleThumbnailWrapper = styled('article')({
  position: 'relative',
  // textAlign: 'center',
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
  gridColumnGap: '2em',
  alignItems: 'center',

  [css.breakpoint.m_down]:{
    display: 'block',
  }
})

const ArticleThumbnailOverlay = styled('div')({
  // background: 'linear-gradient(to top, hsla(30, 14%, 93%, 1) 20%, transparent 60%)',
  position: 'absolute',
  zIndex: 10,
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  textAlign: 'center',

  transition: css.transition.norm,

  // background: 'hsla(30, 2%, 60%, 0.3)',
  background: 'hsla(30, 30%, 60%, 0.15)',
  // background: 'hsla(30, 14%, 93%, 0.2)',
  // borderRadius: '4px',

  '&:hover, &:focus':{
    background: 'hsla(30, 30%, 60%, 0.05)',
    // background: 'hsla(30, 14%, 93%, 0)',
  },

  [css.breakpoint.m_down]:{
    '& > div':{
      padding: '1.5em 2em !important',
      '& h2':{
        marginTop: 0,
        lineHeight: '1.3em',
      },
    }
  },
})

const ArticleThumbnail = (article) => {
  const featured_image = article.featured_image && article.featured_image.w1000 && article.featured_image.w1000.url
  const cat = article.category || {}
  const image_size = article.big && window.innerWidth > css.breakpoints.m ? '400px' : '250px'
  return (
    <ArticleThumbnailWrapper 
      // style={{gridColumn: article.index===0 ? 'span 2' : 'span 1'}}
      // style={{ display: 'grid'}}
    >
      <Link to={`/articles/${article.slug}`}>
        <div style={{position: 'relative'}}>
        <Img
          src={featured_image}
          nospinner
          height={image_size}
          style={{
            // background: css.color.offwhitedark,
            height: '100%',
            objectFit: 'cover',
            // borderRadius: '4px',
          }}
        />
        <ArticleThumbnailOverlay/>
        </div>
        {/* <ArticleThumbnailOverlay>
          <div style={{padding: '2em 1em'}}>
            <h2 style={{ marginBottom: '0.25em', color: css.color.white,}}>{article.title}</h2>
            <div style={{ color: css.color.white,}}>{article.subtitle}</div>
          </div>
        </ArticleThumbnailOverlay> */}
      </Link>

      <div style={{textAlign: 'Xcenter', padding: '1em'}}>
        <div style={{fontSize: '0.6em', textTransform: 'uppercase', fontFamily: css.font.heading, letterSpacing: '0.05em'}}>
          {cat.title || 'Feature'}
        </div>
        <Link to={`/articles/${article.slug}`}>
          <h2 style={{ margin: '0.2em 0', fontSize: '1.7em', lineHeight: '1.1em' }}>{preventWidowedWords(article.title)}</h2>
        </Link>
        <div Xstyle={{maxWidth: '270px', margin: '0 auto', fontSize: '0.9em'}}>{article.subtitle}</div>
      </div>

    </ArticleThumbnailWrapper>
  )
}

export default ArticleThumbnail